<div class="share-wrapper" (click)="$event.stopPropagation()">
   <!-- IRI Report style button -->
   <button
      *ngIf="isIRIReport"
      class="btn__rate"
      (click)="toggleVisibility()"
      [ngClass]="type"
   >
      <span style="display: block;">Share</span>
   </button>

   <!-- Default style button -->
   <ng-container *ngIf="!isIRIReport">
     <div *ngIf="hasShareButtonSlot" (click)="toggleVisibility()">
       <ng-content></ng-content>
     </div>
     <button
       *ngIf="!hasShareButtonSlot"
       type="button"
       class="btn flex-shrink-0 d-flex align-items-center gap-2 shadow-none"
       (click)="toggleVisibility()"
       [ngClass]="type"
     >
       <span>Share</span>
       <svg
         class="share-svg flex-shrink-0"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 24 24"
         color="currentColor"
         fill="none"
       >
         <path
           d="m20.393 8.032-1.747-1.517c-1.259-1.093-1.752-1.681-2.434-1.474-.85.26-.57 1.895-.57 2.447-1.321 0-2.695-.101-3.998.11-4.3.7-5.644 3.759-5.644 7.055 1.217-.747 2.433-1.578 3.895-1.924 1.826-.432 3.865-.226 5.747-.226 0 .552-.28 2.188.57 2.447.772.236 1.175-.38 2.434-1.473l1.747-1.517C21.464 11.03 22 10.564 22 9.996s-.536-1.034-1.607-1.964"
           stroke="currentColor"
           stroke-width="2"
           stroke-linecap="round"
           fill="currentColor"
           stroke-linejoin="round"
         />
         <path
           d="M10.568 3c-3.86.007-5.882.102-7.174 1.39C2 5.783 2 8.022 2 12.5s0 6.717 1.394 8.109C4.788 22 7.032 22 11.52 22s6.73 0 8.125-1.391C20.615 19.64 20.91 18.26 21 16"
           stroke="currentColor"
           stroke-width="2"
           stroke-linecap="round"
           stroke-linejoin="round"
         />
       </svg>
     </button>
   </ng-container>

   <article
      class="bg-white border share-links-wrapper"
      *ngIf="isShareLinksVisible"
      [ngClass]="position"
   >
      <h6 class="text-center fw-600 text-dark mb-2">Share</h6>
      <div class="d-flex align-items-center flex-wrap share-links">
         <ng-template #tipContent> {{ tooltipText }}</ng-template>
         <button
            [url]="shareUrl"
            class="btn flex-shrink-0 shadow-none text-dark rounded-circle share-btn copy-link"
            (click)="onCopySuccess(tooltip)"
            [autoClose]="false"
            [ngbTooltip]="tipContent"
            #tooltip="ngbTooltip"
            shareButton="copy"
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               width="20"
               height="20"
               color="currentColor"
               fill="none"
               *ngIf="tooltipText === 'Copy Link'"
            >
               <path
                  d="M10 13.229C10.1416 13.4609 10.3097 13.6804 10.5042 13.8828C11.7117 15.1395 13.5522 15.336 14.9576 14.4722C15.218 14.3121 15.4634 14.1157 15.6872 13.8828L18.9266 10.5114C20.3578 9.02184 20.3578 6.60676 18.9266 5.11718C17.4953 3.6276 15.1748 3.62761 13.7435 5.11718L13.03 5.85978"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
               />
               <path
                  d="M10.9703 18.14L10.2565 18.8828C8.82526 20.3724 6.50471 20.3724 5.07345 18.8828C3.64218 17.3932 3.64218 14.9782 5.07345 13.4886L8.31287 10.1172C9.74413 8.62761 12.0647 8.6276 13.4959 10.1172C13.6904 10.3195 13.8584 10.539 14 10.7708"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
               />
            </svg>
            <svg
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               width="20"
               height="20"
               color="currentColor"
               fill="none"
               *ngIf="tooltipText === 'Copied'"
            >
               <path
                  d="M5 14L8.5 17.5L19 6.5"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
               />
            </svg>
         </button>

         <button
            [url]="shareUrl"
            class="btn flex-shrink-0 shadow-none text-white rounded-circle share-btn facebook"
            shareButton="facebook"
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               width="20"
               height="20"
               color="currentColor"
               fill="none"
            >
               <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.18182 10.3333C5.20406 10.3333 5 10.5252 5 11.4444V13.1111C5 14.0304 5.20406 14.2222 6.18182 14.2222H8.54545V20.8889C8.54545 21.8081 8.74951 22 9.72727 22H12.0909C13.0687 22 13.2727 21.8081 13.2727 20.8889V14.2222H15.9267C16.6683 14.2222 16.8594 14.0867 17.0631 13.4164L17.5696 11.7497C17.9185 10.6014 17.7035 10.3333 16.4332 10.3333H13.2727V7.55556C13.2727 6.94191 13.8018 6.44444 14.4545 6.44444H17.8182C18.7959 6.44444 19 6.25259 19 5.33333V3.11111C19 2.19185 18.7959 2 17.8182 2H14.4545C11.191 2 8.54545 4.48731 8.54545 7.55556V10.3333H6.18182Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linejoin="round"
               />
            </svg>
         </button>

         <button
            [url]="shareUrl"
            class="btn flex-shrink-0 shadow-none text-white rounded-circle share-btn linkedin"
            shareButton="linkedin"
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               width="20"
               height="20"
               color="currentColor"
               fill="none"
            >
               <path
                  d="M4.5 9.5H4C3.05719 9.5 2.58579 9.5 2.29289 9.79289C2 10.0858 2 10.5572 2 11.5V20C2 20.9428 2 21.4142 2.29289 21.7071C2.58579 22 3.05719 22 4 22H4.5C5.44281 22 5.91421 22 6.20711 21.7071C6.5 21.4142 6.5 20.9428 6.5 20V11.5C6.5 10.5572 6.5 10.0858 6.20711 9.79289C5.91421 9.5 5.44281 9.5 4.5 9.5Z"
                  stroke="currentColor"
                  stroke-width="2"
               />
               <path
                  d="M6.5 4.25C6.5 5.49264 5.49264 6.5 4.25 6.5C3.00736 6.5 2 5.49264 2 4.25C2 3.00736 3.00736 2 4.25 2C5.49264 2 6.5 3.00736 6.5 4.25Z"
                  stroke="currentColor"
                  stroke-width="2"
               />
               <path
                  d="M12.326 9.5H11.5C10.5572 9.5 10.0858 9.5 9.79289 9.79289C9.5 10.0858 9.5 10.5572 9.5 11.5V20C9.5 20.9428 9.5 21.4142 9.79289 21.7071C10.0858 22 10.5572 22 11.5 22H12C12.9428 22 13.4142 22 13.7071 21.7071C14 21.4142 14 20.9428 14 20L14.0001 16.5001C14.0001 14.8433 14.5281 13.5001 16.0879 13.5001C16.8677 13.5001 17.5 14.1717 17.5 15.0001V19.5001C17.5 20.4429 17.5 20.9143 17.7929 21.2072C18.0857 21.5001 18.5572 21.5001 19.5 21.5001H19.9987C20.9413 21.5001 21.4126 21.5001 21.7055 21.2073C21.9984 20.9145 21.9985 20.4432 21.9987 19.5006L22.0001 14.0002C22.0001 11.515 19.6364 9.50024 17.2968 9.50024C15.9649 9.50024 14.7767 10.1531 14.0001 11.174C14 10.5439 14 10.2289 13.8632 9.995C13.7765 9.84686 13.6531 9.72353 13.505 9.63687C13.2711 9.5 12.9561 9.5 12.326 9.5Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linejoin="round"
               />
            </svg>
         </button>

         <button
            [url]="shareUrl"
            class="btn flex-shrink-0 shadow-none text-white rounded-circle share-btn whatsapp"
            shareButton="whatsapp"
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               width="20"
               height="20"
               color="currentColor"
               fill="none"
            >
               <path
                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linejoin="round"
               />
               <path
                  d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
                  stroke="currentColor"
                  stroke-width="2"
               />
            </svg>
         </button>

         <button
            [url]="shareUrl"
            class="btn flex-shrink-0 shadow-none text-white rounded-circle share-btn twitter"
            shareButton="twitter"
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 24 24"
               width="20"
               height="20"
               color="currentColor"
               fill="none"
            >
               <path
                  d="M3 21L10.5484 13.4516M21 3L13.4516 10.5484M13.4516 10.5484L8 3H3L10.5484 13.4516M13.4516 10.5484L21 21H16L10.5484 13.4516"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
               />
            </svg>
         </button>
      </div>
   </article>

   <!-- <div class="d-flex align-items-center bg-white border rounded-3 p-1 shadow flex-wrap share-links" *ngIf="isShareLinksVisible">
      <share-buttons
         theme="modern-dark"
         [include]="['copy']"
         [showIcon]="true"
         [showText]="false">
      </share-buttons>
      <share-buttons
         theme="modern-dark"
         [include]="['facebook']"
         [showIcon]="true"
         [showText]="false">
      </share-buttons>
      <share-buttons
         theme="modern-dark"
         [include]="['linkedin']"
         [showIcon]="true"
         [showText]="false">
      </share-buttons>
      <share-buttons
         theme="modern-dark"
         [include]="['whatsapp']"
         [showIcon]="true"
         [showText]="false">
      </share-buttons>

      <button class="btn text-center shadow-none rounded bg-dark text-white" style="margin: .3125em; width: 57.75px; height: 35px;" shareButton="twitter">
         <svg class="block mx-auto" width="14" height="14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/>
         </svg>
      </button>
   </div> -->
</div>
